export default __webpack_public_path__ + "static/fall25-f255393dfcd8bb573dbca8d02da8b3b1.webp";